<script>

  /*
  |--------------------------------------------------------------------------
  | Dependency Definitions
  |--------------------------------------------------------------------------
  */

  import Vue from 'vue';

  import axios from 'axios';

  import LikeButton from './components/LikeButton';



  /*
  |--------------------------------------------------------------------------
  | Component Implementation
  |--------------------------------------------------------------------------
  */

  export default {
    name: 'like-product',

    props: [
      'productID',
      'liked',
      'mode',
      'language'
    ],

    components: {
      LikeButton
    },

    mounted() {
      this.currentLiked = this.liked;
    },

    data() {
      return {
        currentLiked: false
      }
    },

    computed: {
      addedText() {
        if (this.language == 'sv') {
          if (this.currentLiked) {
            return 'Produkten finns redan i din lista';
          }

          return 'Spara produkten';
        }

        if (this.language == 'en') {
          if (this.currentLiked) {
            return 'Product added';
          }

          return 'Save product';
        }

        if (this.currentLiked) {
          return 'Produkten finns redan i din lista';
        }

        return 'Spara produkten';
      },

      buttonText() {
        if (this.language == 'sv') {
          return 'Se dina produkter';
        }

        if (this.language == 'en') {
          return 'View your products';
        }

        return 'Se dina produkter';
      }
    },

    methods: {
      productLiked(state) {
        this.currentLiked = state;

        console.log("Mode: ", this.mode);

        if (this.mode == 'account') {
          console.log("Reload");
          location.reload(true);
        }
      }
    }
  };
</script>

<template>
  <div>
    <like-button v-if="mode == 'mini'" :product-i-d="productID" :liked="liked" :mode="mode" :language="language" />

    <like-button v-if="mode == 'account'" :product-i-d="productID" :liked="liked" :mode="mode" :language="language" @productLiked="productLiked" />

    <div v-if="mode == 'full'">
      <like-button :product-i-d="productID" :liked="liked" :mode="mode" :language="language" @productLiked="productLiked" class="mb-3" />
      <a v-if="currentLiked && language == 'sv'" href="/account/" class="btn btn-outline-dark mb-4">{{ buttonText }}</a>
      <a v-if="currentLiked && language == 'en'" href="/en/account/" class="btn btn-outline-dark mb-4">{{ buttonText }}</a>
    </div>
  </div>
</template>

<style lang="scss" scoped>

</style>
